<template>
  <div class="cd_issues">
    <h2 v-if="this.$route.params.category">{{this.$route.params.category}} Pollution Issues</h2>
    <h2 v-else>Pollution Issues</h2>

    <ul class="cd_issues--filter mb-2">
      <li v-for="(category,index) in categories" :key="index" :class="categoryActiveClass(category)">
        <router-link v-if="category.name != 'All'" :to="{ name: 'pollutionCategory', params: {category: category.name}}">{{category.name}}</router-link>
        <router-link v-else :to="{ name: 'pollution'}">{{category.name}}</router-link>
      </li>
    </ul>

    <ul class="cd_issues--cards" v-if="issues.length > 0">
      <li v-for="(issue,index) in issues" :key="index">
        <IssueCard :issue="issue" />
      </li>
    </ul>
    <ul v-else>
      <li v-if="this.$route.params.category">No {{this.$route.params.category}} have been reported</li>
      <li v-else>No Issues have been reported</li>
    </ul>
  </div>
</template>

<script>
  import IssueCard from './issue-card'
  import { API } from 'aws-amplify';
  import { listIssues } from '@/graphql/queries';

  export default {
    name: 'Issues',
    components: {
      IssueCard
    },
    async created() {
      this.getIssues();
    },
    data () {
      return {
        issues: [],
        categories: [
          {name: "All"},
          {name: "Chemical"},
          {name: "Dredge"},
          {name: "Oil"},
          {name: "Sewage"},
          {name: "Stormwater"},
          {name: "Trash"},
          {name: "Other"}
        ]
      }
    },
    methods: {
      async getIssues() {
        let variables
        if (this.$route.params.category != undefined){
          variables = {
            filter: {
              category: {
                eq: this.$route.params.category
              },
              approved: {
                eq: true
              }
            },
            limit: 8
          }
        } else {
          variables = {
            filter: {
              approved: {
                eq: true
              }
            },
            limit: 8
          }
        }

        const issues = await API.graphql({
          query: listIssues,
          variables
        })
        .catch(err => console.log(err))
        let unsorted_issues = issues.data.listIssues.items
        let sorted_issues = unsorted_issues.slice().sort((a,b) => new Date(b.updatedAt) - new Date(a.updatedAt))
        this.issues = sorted_issues
      },
      categoryActiveClass(category) {
        if (!this.$route.params.category && category.name == "All"){
          return 'active'
        }
        return category.name == this.$route.params.category ? 'active': ''
      }
    },
    watch: {
      '$route.params'(){
        this.getIssues()
      }
    }
  }
</script>
